export default __webpack_public_path__ + "static/media/audio.368b5378.mp3";